import axios from 'axios';

const path = 'AdminDashboard';
const apiPath = '/admin-panal/dashboard/get-statistic-data';

export const AdminDashboardActions = {
   GET_DATA: `${path}/getData`,
};

export const AdminDashboardAPIsConstants = {
   API_PATH: apiPath,
};

const AdminDashboard = {
   namespaced: true,
   state: {
      loading: false,
      data: {},
   },
   mutations: {
      SET_LOADING(state, payload) {
         state.loading = payload;
      },
      SET_DATA(state, payload) {
         state.data = payload;
      },
   },
   actions: {
      getData({ commit }, { params }) {
         commit('SET_LOADING', true);

         return axios
            .get(AdminDashboardAPIsConstants.API_PATH, { params })
            .then(({ data }) => {
               commit('SET_DATA', data.result);
               return data;
            })
            .finally(() => commit('SET_LOADING', false));
      },
   },
};

export default AdminDashboard;
